import type { EnumObjectToUnion } from "@/utils/enum";

export const TAB_FILTER = {
  INTEGRATIONS: "INTEGRATIONS",
  CUSTOM_APPS: "CUSTOM_APPS",
  DEACTIVATED: "DEACTIVATED",
  ALL: "ALL",
} as const;

export type TabFilter = EnumObjectToUnion<typeof TAB_FILTER>;

export const TAB_ITEMS = {
  SAAS: "SAAS",
  INSTALLED: "INSTALLED",
  MIDDLEWARE_AND_OS: "MIDDLEWARE_AND_OS",
  SCRATCH: "SCRATCH",
  PRODUCT: "PRODUCT",
  ALL: "ALL",
  DEACTIVATED: "DEACTIVATED",
} as const;

export type TabItems = EnumObjectToUnion<typeof TAB_ITEMS>;
